import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { Link as IsoLink } from 'react-isomorphic-render';

/**
 * Because React-Isomorphic-Render will ignore preloading if you double click a link,
 * we have to prevent links from being double clicked.  We use withRouter to detect location
 * changes and re-enable a link once the route changes.
 *
 * TODO: STORE-3159 This works for an individual link,
 * but we need to account for the case of two links
 */
class BetterLink extends React.Component {
  static propTypes = {
    location: PropTypes.shape({ pathname: PropTypes.string }),
    onClick: PropTypes.func,
    to: PropTypes.string,
    children: PropTypes.node,
  }

  static defaultProps = {
    location: {},
    onClick: _.noop,
    to: null,
    children: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
      prevPathname: props.location.pathname,
    };
  }

  /**
   * Invalidate click prevention.  When route changes, we can safely click again
   */
  static getDerivedStateFromProps(props, state) {
    if (props.location.pathname !== state.prevPathname) {
      return {
        clicked: false,
        prevPathname: props.location.pathname,
      };
    }
    return null;
  }

  /**
   * Prevent react-ismorphic double-clicks.
   */
  onClick = (event) => {
    if (this.state.clicked) {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    } else {
      this.props.onClick(event);
      this.setState({
        clicked: true,
      });
    }
  }

  render() {
    let LinkElement = IsoLink;
    // Remove react-isomorphic link so it doesn't even attempt to not preload/navigate prematurely
    if (this.state.clicked) {
      LinkElement = () => (
        <a {...this.props} href={this.props.to} onClick={this.onClick}>{this.props.children}</a>
      );
    }
    return (
      <LinkElement {...this.props} onClick={this.onClick}>
        <span>
          {this.props.children}
        </span>
      </LinkElement>
    );
  }
}

export default withRouter(BetterLink);



// WEBPACK FOOTER //
// ./app/common/components/link.jsx